import { Box, Stack, Typography } from "@mui/material";
import { Icon } from "../../../icons";
import { OssPanel } from "./OssPanel";

export const OssPageHeader = ({ title, icon, iconName, actions }) => (
  <OssPanel
    sx={{
      minHeight: 66,
      px: { xs: 1.8, sm: 2.25 },
      py: 1.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1.6,
      flexWrap: { xs: "wrap", sm: "nowrap" },
    }}
  >
    <Stack direction="row" alignItems="center" spacing={1.1} sx={{ minWidth: 0 }}>
      {iconName ? (
        <Box
          sx={{
            width: 26,
            height: 26,
            display: "grid",
            placeItems: "center",
            color: "#6c5ce7",
            "& svg": { display: "block", width: 22, height: 22, margin: 0 },
          }}
        >
          <Icon name={iconName} width={22} height={22} />
        </Box>
      ) : (
        icon
      )}
      <Typography
        component="h1"
        noWrap
        sx={{
          fontSize: { xs: "21px !important", md: "24px !important" },
          fontWeight: "900 !important",
          color: "#111827",
          lineHeight: 1.25,
        }}
      >
        {title}
      </Typography>
    </Stack>
    {actions && (
      <Stack direction="row" spacing={0.8} alignItems="center" sx={{ ml: "auto" }}>
        {actions}
      </Stack>
    )}
  </OssPanel>
);
